import React from "react";
import TableFilter from "./TableFilter";
import TableSort from "./TableSort";
import { classNames } from "../../../helpers/classNames";
import Checkbox from "../../form/Checkbox";

const Th = ({
  name,
  nameAlign,
  isSort,
  isFilter,
  isFilterSearch,
  filterDropdown,
  type,
  onSort = () => {},
  onFilter = () => {},
  filterSearch = () => {},
  handleCheckboxChange,
  onCheckboxChange,
  checkboxChecked,
  ...props
}) => {
  const align = {
    left: "justify-start",
    right: "justify-end",
    center: "justify-center",
    "": "justify-start",
  };
  return (
    <>
      <th
        className={classNames(
          "py-4 px-2 text-left max-w-[240px] border-none bg-blue-zodiac first:rounded-tl-md last:rounded-tr-md border-blue-zodiac first:border-l last:border-r",
          "last:right-0"
        )}
      >
        <div
          className={classNames(
            "flex items-center gap-1 w-full",
            align[nameAlign]
          )}
        >
          <div className="text-xs uppercase font-semibold text-white">
            {name}
          </div>
          {type === "checkbox" && (
            <Checkbox isChecked={checkboxChecked} onChange={onCheckboxChange} />
          )}
          {(isSort || isFilter) && (
            <div className="flex justify-end items-center flex-shrink-0">
              {isSort && <TableSort sortState={"nostate"} onSort={onSort} />}
              {isFilter && (
                <TableFilter
                  xPlacement={"right"}
                  filterData={filterDropdown}
                  isFilterSearch={isFilterSearch}
                  filterSearch={filterSearch}
                  onFilter={onFilter}
                />
              )}
            </div>
          )}
        </div>
      </th>
    </>
  );
};

export default Th;
